/**
 * @generated SignedSource<<e4ce475c607252ee0cece63d9015c5f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespHolidayGiftCollectionLinks_browseContentModule$data = {
  readonly tiles: ReadonlyArray<{
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly localizedLinkDataList: ReadonlyArray<{
      readonly currency: string | null;
      readonly linkData: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
    } | null> | null;
    readonly title: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbRespHolidayGiftCollectionLinks_browseContentModule";
};
export type SbRespHolidayGiftCollectionLinks_browseContentModule$key = {
  readonly " $data"?: SbRespHolidayGiftCollectionLinks_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespHolidayGiftCollectionLinks_browseContentModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespHolidayGiftCollectionLinks_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrowseContentModuleTile",
      "kind": "LinkedField",
      "name": "tiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalizedLinkData",
          "kind": "LinkedField",
          "name": "localizedLinkDataList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleBannerTiles",
  "abstractKey": null
};
})();

(node as any).hash = "fff036f0f025ae8e9e822b2d3be17bec";

export default node;
